module.exports = __webpack_public_path__ + "static/media/multimedia-option.fdf0bac0.svg";